import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BrandingContext = createContext({ logos: {} });

export function BrandingProvider({ children }) {
  const [logos, setLogos] = useState({});

  useEffect(() => {
    axios.get(`${API}/branding/config`)
      .then(res => setLogos(res.data.placements || {}))
      .catch(() => {});
  }, []);

  return (
    <BrandingContext.Provider value={{ logos }}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding() {
  return useContext(BrandingContext);
}

export function BrandLogo({ slot, fallback, className = '', style = {} }) {
  const { logos } = useBranding();
  const src = logos[slot];
  if (!src) {
    return fallback || null;
  }
  return <img src={src} alt="GetChosenFirst" className={className} style={style} />;
}
